import { useState } from "react";
import { Loader2, UserRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ContactForm = ({ initial, onSubmit, onCancel }) => {
  const [f, setF] = useState({ name: initial?.name || "", email: initial?.email || "", phone: initial?.phone || "", note: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim()) return setErr("Please add your name.");
    if (!EMAIL_RE.test(f.email.trim())) return setErr("Please add a valid email.");
    setErr(""); setBusy(true);
    try { await onSubmit({ name: f.name.trim(), email: f.email.trim(), phone: f.phone.trim(), note: f.note.trim() }); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-2 rounded-xl border border-[#D4AF37]/30 bg-[#D4AF37]/5 p-3" data-testid="site-chat-contact-form">
      <p className="flex items-center gap-1.5 text-xs font-medium text-[#F3C649]"><UserRound className="h-3.5 w-3.5" />Connect with a person</p>
      <p className="text-[11px] text-zinc-400">Leave your details and our team will reply by email, usually within a day.</p>
      <Input value={f.name} onChange={set("name")} placeholder="Your name" className="h-9 bg-[#09090B] text-sm" data-testid="site-chat-contact-name" />
      <Input value={f.email} onChange={set("email")} type="email" placeholder="Email address" className="h-9 bg-[#09090B] text-sm" data-testid="site-chat-contact-email" />
      <Input value={f.phone} onChange={set("phone")} placeholder="Phone (optional)" className="h-9 bg-[#09090B] text-sm" data-testid="site-chat-contact-phone" />
      <Input value={f.note} onChange={set("note")} placeholder="Anything else we should know? (optional)" className="h-9 bg-[#09090B] text-sm" data-testid="site-chat-contact-note" />
      {err && <p className="text-[11px] text-red-400" data-testid="site-chat-contact-error">{err}</p>}
      <div className="flex justify-end gap-2">
        {onCancel && <Button type="button" size="sm" variant="ghost" onClick={onCancel} data-testid="site-chat-contact-cancel">Not now</Button>}
        <Button type="submit" size="sm" disabled={busy} data-testid="site-chat-contact-submit">{busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Send to our team</Button>
      </div>
    </form>
  );
};
